<template>
<panel>
    <p slot="header">
        Import wielu adresów e-mail
    </p>
    <p slot="actions">
        <ui-button type="flat" color="primary" icon="navigate_before" @click="$router.push({name: 'admin.emails.dashboard'})">Wróć</ui-button>
    </p>
    <ui-alert :dismissible="false" hide-icon>
        Wklej adresy e-mail w pole poniżej, jeden adres w jednej lini. Adresy zostaną sprawdzone i zostaną dodane tylko te które jeszcze nie istnieją. Jeśli adres e-mail istnieje jego grupy zostaną zmienione na wybrane ponizej.
    </ui-alert>

    <form @submit.prevent="submit" autocomplete="off">
        <ui-alert type="error" v-for="e, index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>

        <ui-textbox label="Wklej adresy e-mail" name="emails" type="text" v-model="item.emails" validation-rules="required" :validation-messages="errorMessages" placeholder="Wklej adresy e-mail" multi-line :rows="8"></ui-textbox>


        <i-select-multiple name="groups" label="Grupy do których będą dodane te adresy" :keys="keysForSelect" v-model="item.groups" :options="groups" search-placeholder="Szukaj" :show-search="true" placeholder="wybierz grupy do których będą dodane te adresy" required></i-select-multiple>

        <div class="form-actions">
            <ui-button color="primary">Importuj wklejone adresy</ui-button>
        </div>
    </form>

</panel>
</template>

<script>
import Notify from './../../mixins/Notify'
import Loading from './../../mixins/Loading'
import FormErrors from './../../mixins/FormErrors'

import Utils from './../../services/Utils'
import EmailGroups from './../../services/EmailGroups'
import Emails from './../../services/Emails'

export default {
  mixins: [Notify, Loading, FormErrors],
  data () {
    return {
      errors: [],
      item: {
        groups: [],
        emails: ''
      },
      groups: [],
      keysForSelect: Utils.keysForSelect(),
      errorMessages: Utils.errorMessages([
        'required',
        'min',
        'numeric',
        'email'
      ])
    }
  },
  mounted () {
    this.getEmailGroups()
  },
  methods: {
    getEmailGroups () {
      this.setLoading(true)
      EmailGroups.names().then(res => {
        this.groups = res.data.items
        this.setLoading(false)
      })
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notifyError('Wystąpiły błędy')
    },
    success (res) {
      if (res.status === 201) {
        this.notify(
          'Dodałeś ' +
            res.data.created +
            ' nowych adresów e-mail. Zmieniłeś grupy dla ' +
            res.data.changed +
            ' adresów e-mail'
        )
      }
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)

      let data = {}

      data.emails = this.item.emails.split('\n')
      data.email_groups_ids = this.item.groups

      Emails.import(data).then(this.success, this.error)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Import.vue?0350ad40